import { useEffect } from 'react';
import TagManager from 'react-gtm-module';

export interface UseGoogleTagManagerParams {
    gtmIdByUrl: Record<string, string>;
}

function useGoogleTagManager({ gtmIdByUrl }: UseGoogleTagManagerParams): void {
    useEffect(() => {
        for (const url in gtmIdByUrl) {
            if (document.baseURI.match(new RegExp(url, 'i'))) {
                TagManager.initialize({ gtmId: gtmIdByUrl[url] });
                break;
            }
        }
    }, [gtmIdByUrl]);
}

export default useGoogleTagManager;
